import { secondaryNavigationData } from "@/components/navigation/navigationData";

/**
 * Returns the secondary navigation array with the current section marked as active.
 * @param currentName The name of the current section
 */
export function getNavWithCurrent(currentName: string) {
  return secondaryNavigationData.map((item) => ({
    ...item,
    current: item.name === currentName,
  }));
}
